<ng-template [ngIf]="widgetRows && widgetRows.length > 0">
  <button (click)="toggleWidgetSize()" class="textGreen expand-btn font17 absolute cursorPointer"
    [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue'">
    <fa-icon [icon]="faArrowsLeftRight"></fa-icon>
  </button>
  <ng-template [ngIf]="widgetsGridLoaded">
    <div [style.display]="'grid'" style="gap: 5px;" class="padding5"
      [style.gridTemplateColumns]="'repeat(' + maxCols + ', 1fr)'"
      [style.gridTemplateRows]="'repeat(' + maxRows + ', 1fr)'">
      <div *ngFor="let item of gridItems" [ngStyle]="{'grid-column' : item.gridColumn, 'grid-row' : item.gridRow, 
        'background-color' : (!item.widget.type.includes('Chart') || item.widget.type != 'RAG' || item.widget.type != 'Progress Bar') ? item.widget.backGroundColor : '#ffffff', 
        'height': item.height,
        'border': (item.widget.type.includes('Chart') || item.widget.type == 'RAG' || item.widget.type == 'Progress Bar') ? '1px solid var(--green)' : 'unset'}"
        style="min-height: 0; overflow: hidden;" [ngClass]="item.classes" class="b-radius flex">
        <div class="expanded-widget__content">
          <ng-template [ngIf]="!item.widget.type.includes('Chart')">
            <ng-template [ngIf]="item.widget.type != 'RAG' && item.widget.type != 'Progress Bar'">
              <span class="expanded-widget__caption textWhite">
                {{ item.widget.caption }}
              </span>
              <span class="expanded-widget__value"
                [ngStyle]="{'color' : item.widget.primaryColor ? item.widget.primaryColor : 'var(--green)'}">
                {{ item.widget.value }}
              </span>
              <ng-template [ngIf]="item.widget.type == 'Trend' && item.widget.trend">
                <span class="expanded-widget__icon">
                  <fa-icon [icon]="item.widget.trend == '+' ? faArrowTrendUp : faArrowTrendDown"></fa-icon>
                </span>
              </ng-template>
              <ng-template [ngIf]="item.widget.subText && item.width != 'col-4'">
                <span class="expanded-widget__subtext"
                  [ngStyle]="{'color' : item.widget.secondaryColor ? item.widget.secondaryColor : 'white'}">
                  {{ item.widget.subText }}
                </span>
              </ng-template>
            </ng-template>
            <ng-template [ngIf]="item.widget.type == 'RAG'">
              <span class="expanded-widget__caption" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{ item.widget.caption }}
              </span>
              <div class="absolute" style="font-size: 80px; top: 50%; transform: translateY(-50%); right: 0;"
                *ngIf="item.widget.value == 'AMBER'">🟡</div>
              <div class="absolute" style="font-size: 80px; top: 50%; transform: translateY(-50%); right: 0;"
                *ngIf="item.widget.value == 'RED'">🔴</div>
              <div class="absolute" style="font-size: 80px; top: 50%; transform: translateY(-50%); right: 0;"
                *ngIf="item.widget.value == 'GREEN'">🟢</div>
            </ng-template>
            <ng-template [ngIf]="item.widget.type == 'Progress Bar'">
              <span class="expanded-widget__caption" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{ item.widget.caption }}
              </span>
              <div class="flex" style="transform: translateY(60px); width: 100%;">
                <span class="text-centre font15" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                  style="padding: 0px 5px">{{item.widget.value.MinValue}}</span>
                <div [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                  style="height: 20px; width: 100%; max-width: 100%; background-color: aliceblue; border-radius: 50px;">
                  <div class=" flex"
                    [ngStyle]="{'width': calculatePercentage(item.widget.value.MinValue, item.widget.value.MaxValue, item.widget.value.RandomValue)}"
                    style="height: 20px; max-width: 90%; background-color: var(--blue); border-radius: 50px; justify-content: center; align-items: center;">
                    <span class="textWhite text-centre font15">{{item.widget.value.RandomValue}}</span>
                  </div>
                </div>
                <span class="text-centre font15" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                  style="padding: 0px 5px;">{{item.widget.value.MaxValue}}</span>
              </div>
            </ng-template>
          </ng-template>
          <ng-template [ngIf]="item.widget.type.includes('Chart')">
            <chart [settings]="settings" [widget]="item.widget" [maximised]="true" style="width: 100%;"></chart>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>